import Aurelia from 'aurelia';
import Home from './home';

import 'op-flex/op-flex.css';

Aurelia.app({component: Home, host: document.body}).start();
